var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.componentClasses},[_c(_setup.Loader),_vm._v(" "),_c('div',{staticClass:"stk-loader-with-text-body"},[_vm._t("default",function(){return [_vm._v("\n      Loading…\n    ")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }